export const navMenuItems: Array<NavMenuItem> = [
  {
    href: '#works',
    label: 'How It Works?',
  },

  {
    href: '#about',
    label: 'About',
  },

  {
    href: '#practice-areas',
    label: 'Practice Areas',
  },

  {
    href: '#packages',
    label: 'Packages',
  },

  {
    href: '#careers',
    label: 'Careers',
  },

  {
    href: '#contact',
    label: 'Contact Us',
  },
];
